import { fetcher } from "../../../utils/Axios";
import { useQuery } from "@tanstack/react-query";
import { GET_CASE_RECOVERY_HANDOFF_TIME_QUERY_KEY } from "../types/CommonTypes";
import { GET_CASE_RECOVERY_HANDOFF_TIME_RESPONSE } from "../types/ResponseTypes";

async function getCaseRecoveryHandOffTime(
  tenantId?: string,
  hospitalId?: string,
  queryString?: string
): Promise<GET_CASE_RECOVERY_HANDOFF_TIME_RESPONSE> {
  const baseUrl = "analytics/recovery-handoff-time";
  const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

  const { data } = await fetcher({
    url,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

export default function useGetCaseRecoveryHandOffTimeQuery(
  tenantId?: string,
  hospitalId?: string,
  queryString: string = ""
) {
  return useQuery({
    queryKey: [
      GET_CASE_RECOVERY_HANDOFF_TIME_QUERY_KEY,
      queryString,
      hospitalId,
    ],
    queryFn: () =>
      getCaseRecoveryHandOffTime(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
    enabled: !!tenantId && !!hospitalId,
  });
}
